export default __webpack_public_path__ + "static/media/SJA1520.34I-42091_-25236_0.23e22aee.jpg";